export const DELETE_CHALLENGE_ERROR = {
  severity: 'error',
  summary: 'Failed',
  detail: 'Your challenge was not removed. Please try again and if the issue persists contact support.leasehawk.com.',
};
export const DELETE_CHALLENGE_SUCCESS = {
  severity: 'success',
  summary: 'Removed',
  detail: 'Your challenge has been removed from reviewing.',
};

export const APPROVE_CHALLENGE_ERROR = {
  severity: 'error',
  summary: 'Failed',
  detail:
    'There was an issue with the approval process. Please try again and if the issue persists contact support.leasehawk.com.',
};
export const APPROVE_CHALLENGE_SUCCESS = {
  severity: 'success',
  summary: 'Approved',
  detail: 'Challenge has been approved.',
};

export const DENY_CHALLENGE_ERROR = {
  severity: 'error',
  summary: 'Failed',
  detail:
    'There was an issue with the approval process. Please try again and if the issue persists contact support.leasehawk.com.',
};
export const DENY_CHALLENGE_SUCCESS = {
  severity: 'success',
  summary: 'Denied',
  detail: 'Challenge has been denied.',
};

export const CREATE_CHALLENGE_ERROR = {
  severity: 'error',
  summary: 'Failed',
  detail: 'Your challenge was not saved. Please try again and if the issue persists contact support.leasehawk.com.',
};
export const CREATE_CHALLENGE_SUCCESS = {
  severity: 'success',
  summary: 'Saved',
  detail: 'Your challenge has been submitted for review.',
};
